import { Dayjs } from 'dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/css';

import dayjsGenerateConfig from './generateConfig';

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default DatePicker;
